import Swal from 'sweetalert2';

export const swalColors = {
  primary: '#1E60DD',
  secondary: '#7DA0FA',
  info: '#3699ff',
  danger: '#f64e60',
  success: '#0bb7af',
  warning: '#ee9d01',
  dark: '#001e3c',
  light: '#ffffff',
};

export const swalButtonClasses = {
  confirm: 'app-btn-buttonColor',
  cancel: 'swal-cancel-button',
  deny: 'swal-deny-button',
};

export const swalButtonStyles = {
  primary: {
    confirmButtonColor: swalColors.primary,
  },
  delete: {
    confirmButtonColor: swalColors.danger,
    cancelButtonColor: swalColors.primary,
    customClass: {
      confirmButton: 'app-btn-red-btn',
      cancelButton: swalButtonClasses.cancel,
    },
  },
  warning: {
    confirmButtonColor: swalColors.danger,
  },
  success: {
    confirmButtonColor: swalColors.primary,
  },
  error: {
    confirmButtonColor: swalColors.primary,
  },
  info: {
    confirmButtonColor: swalColors.primary,
  },
};

export const showSwal = (options, type = 'primary') => {
  const buttonStyles = swalButtonStyles[type] || swalButtonStyles.primary;

  return Swal.fire({
    ...options,
    ...buttonStyles,
    customClass: {
      confirmButton: swalButtonClasses.confirm,
      cancelButton: swalButtonClasses.cancel,
      ...(options.customClass || {}),
      ...(buttonStyles.customClass || {}),
    },
  });
};
